module.exports = "https://coursera_assets.s3.amazonaws.com/images/8807ef2fff498e27cdd19eba63aea985.png";